import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useDropzone } from 'react-dropzone'
import UrlImageDropZone from './UrlImageDropZone';
import { Eye } from '../../assets/svgs';
import TrashBin from '../../assets/svgs/trashBin';
import CreateFileAction from '../operational/createFileAction';
import { UploadImageAsFormData } from '../operational/UploadImageAsFormData'
import { translate } from '../../utils/language';
import { blobData } from '../../helper/Converters';
import { fileToBlobConverter } from '../../helper/Converters';
import { useDispatch } from 'react-redux';
import systemSlice from '../../redux/systemSlice';
import { v4 as uuid } from 'uuid';

import { useSelector } from 'react-redux/es/hooks/useSelector';
const UploadImgPublish = (props: { obJectFit?: any, text: string, reset?: any, preImage: any, styleSpecial?: any, uploadType?: any, resolution?: any, boxWidth?: any, boxHeight?: any, specialDesc?: any, error?: any, setImage?: any, imageWidth: any, imageHeight: any, loading?: any, type: any, color: any, onChange: any, label: any, placeholder?: any, value?: any, output: { width: number, height: number }, imageText?: string, required?: boolean, accept?: any }) => {
    const { obJectFit, reset, output, color, label, placeholder, resolution, styleSpecial, loading, setImage, preImage, boxHeight, uploadType, error, value, boxWidth, specialDesc, type, onChange, imageHeight, imageWidth, text, imageText, required, accept } = props;
    const [selectedFile, setSelectedFile] = useState('');
    const [preview, setPreview] = useState(false);
    const [isError, setIsError] = useState(false);
    const [reduxId, setReduxId] = useState("")
    const [originalImage, setOriginalImage] = useState({ blobImage: "", type: "" })
    const uploadedImage = useSelector((state: any) => state.systemSlice.croppedImages)?.[reduxId] || {};

    useEffect(() => {
        setReduxId(uuid())
    }, [])
    const dispatch = useDispatch()


    const handleFileUpload = async (acceptedFiles: any) => {
        const type = acceptedFiles[0]?.type
        const blob = new Blob([acceptedFiles[0]], { type })
        //@ts-ignore
        if (blob) {
            const blobImage = URL.createObjectURL(blob)
            if (blobImage) {
                setOriginalImage({ blobImage, type })
                dispatch(systemSlice.actions.setImageCropperSettings({ image: blobImage, aspectRatio: output.width / output.height, id: reduxId, boxWidth: output.width, boxHeight: output.height, type }))
            }
        }
        // const response = await UploadImageAsFormData(acceptedFiles[0])
        // //@ts-ignore

        // if (!response || response?.error) return setIsError(translate("imageCouldNotBeUploaded"))
        // //@ts-ignore
        // const photoUrl = response?.data?.url
        // setSelectedFile(photoUrl);
        // onChange(photoUrl);
        // setIsError(false);

    };
    const handleClickPreviewIcon = (e: any) => {
        dispatch(systemSlice.actions.setImageCropperSettings({ ...(uploadedImage || {}), image: originalImage.blobImage, aspectRatio: output.width / output.height, id: reduxId, boxWidth: output.width, boxHeight: output.height, type: originalImage.type }))
    }
    const handleClickDeleteIcon = (e: any) => {
        setSelectedFile('');
        onChange("")
    }

    useEffect(() => {
        setSelectedFile(preImage);
        setIsError(false)
    }, [preImage])

    useEffect(() => {
        if (uploadedImage?.image) {
            setSelectedFile(uploadedImage?.image);
            setIsError(false)
            onChange(uploadedImage?.image)
        }
    }, [uploadedImage])
    return (

        <div className='w-[100%] h-full'>
            <div className={`imageEditParent bg-white flex w-[100%] border-0 border-dashed relative rounded-xl overflow-hidden h-[100%] flex flex-row justify-center shrink-0`} style={{ width: boxWidth + "px", height: boxHeight + "px" }}  >
                <style>
                    {`.imageEditParent:hover .imageEdit{
                        display:flex
                    }`}
                </style>
                {selectedFile ?
                    <div className='w-[100%] h-[100%] relative flex justify-center items-center border-2 border-[#7059ef] overflow-hidden rounded-xl'>
                        <div className={`hidden imageEdit absolute top-0 left-0 w-[100%] h-full bg-white bg-opacity-40 overflow-hidden`}>
                            {originalImage?.blobImage && <div className=' w-[100%] h-full flex flex-col justify-center items-center'>
                                <Eye className="hover:fill-[#6837F8] w-[15%]" onClick={handleClickPreviewIcon} />
                            </div>}
                            <TrashBin className='hover:fill-[#6837F8] absolute top-0 right-0 p-2 hover:text-blue-500 w-[30px]' onClick={(e: any) => { handleClickDeleteIcon(e) }} />
                        </div>
                        <div className="text-center justify-center flex flex-col items-center w-full h-full overflow-hidden">
                            <img src={selectedFile} className=' w-full h-full self-center' style={{ objectFit: obJectFit || "contain", maxHeight: `${boxHeight}px`, maxWidth: `${boxWidth}px`, width: `${boxWidth}px`, height: `${boxHeight}px` }} />
                        </div>
                    </div>
                    :
                    <UrlImageDropZone accept={accept} required={required} imageText={imageText} styleSpecial={styleSpecial} isError={isError} uploadType={uploadType} specialDesc={specialDesc} boxWidth={boxWidth} resolution={resolution} boxHeight={boxHeight} text={text} onFileUpload={handleFileUpload} />
                }
            </div>
            {specialDesc && <div className='flex justify-start items-start mt-[10px]'>
                <span className='text-[14px] text-[#8A92A6] font-light text-left text-center'>{specialDesc}</span>
            </div>}


        </div>

    );
};

export default UploadImgPublish;
